import { blockTouchesSprint, allocationOf, DEFAULT_CAPACITY } from './schema';

/** How much of a person's time is booked in a sprint, as a share of what they have available. */
export function memberLoad(roadmap, member, sprint) {
  const away = (member.away || []).includes(sprint);
  const capacity = away ? 0 : member.capacity ?? DEFAULT_CAPACITY;
  const projects = [];
  let booked = 0;
  for (const p of roadmap.projects) {
    if (!p.memberIds.includes(member.id)) continue;
    if (!p.blocks.some((b) => blockTouchesSprint(b, sprint))) continue;
    const allocation = allocationOf(p, member.id);
    booked += allocation;
    projects.push({ project: p, allocation });
  }
  let level = 0;
  if (booked > 0) {
    if (capacity <= 0) level = 3;
    else {
      const ratio = booked / capacity;
      level = ratio <= 0.5 ? 1 : ratio <= 1 ? 2 : 3;
    }
  }
  return {
    sprint,
    booked,
    capacity,
    away,
    projects,
    percent: capacity > 0 ? Math.round((booked / capacity) * 100) : booked > 0 ? Infinity : 0,
    level,
    over: level === 3
  };
}

export function teamLoad(roadmap) {
  const sprints = Array.from({ length: roadmap.settings.sprintCount }, (_, i) => i + 1);
  return roadmap.members.map((member) => ({ member, cells: sprints.map((n) => memberLoad(roadmap, member, n)) }));
}
